// Convex Auth bridge — module-level capture of the `useAuthActions`
// hook's return so lib/api.ts (plain TS module) can call the React-
// hook-bound signIn / signOut from the auth dispatcher.
//
// Web counterpart of src/app/lib/auth/convexBridge.ts. Same shape,
// same semantics — see the mobile file for the design rationale.

export type SignInResult = {
  signingIn?: boolean;
  redirect?: URL;
  started?: boolean;
  tokens?: { token: string; refreshToken: string };
  [k: string]: unknown;
};

export type SignInFn = (
  provider: string,
  params?: Record<string, unknown>,
) => Promise<SignInResult>;
export type SignOutFn = () => Promise<void>;

let _signIn: SignInFn | null = null;
let _signOut: SignOutFn | null = null;

export function setConvexAuthFns(fns: {
  signIn: SignInFn;
  signOut: SignOutFn;
}): void {
  _signIn = fns.signIn;
  _signOut = fns.signOut;
}

export function getConvexSignIn(): SignInFn {
  if (!_signIn) {
    throw new Error(
      'Convex Auth bridge not ready — <ConvexAuthBridge /> must mount before any Convex auth call',
    );
  }
  return _signIn;
}

export function getConvexSignOut(): SignOutFn {
  if (!_signOut) {
    throw new Error(
      'Convex Auth bridge not ready — <ConvexAuthBridge /> must mount before any Convex auth call',
    );
  }
  return _signOut;
}
